import React from 'react';
import Banner from '@cpg-its/ads.containers.banner';
import { BeneficiaryDto } from './model/beneficiary-models';
import { BeneficiarySettings } from './model/epi-props';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../../../../global/components/wysiwyg-with-react-link';
import { GetMappedRelationshipByValue } from './helper/beneficiary-helper';
import { GetMappedRelationship } from './create-beneficiary/helper/create-beneficiary-helper';

interface Props {
	beneficiary: BeneficiaryDto;
	settings: BeneficiarySettings;
	isDesignated?: boolean;

}
export function BeneficiaryView(props: Props) {

	const { settings, beneficiary, isDesignated } = props;
	const mappedRelationship = GetMappedRelationship(settings?.relationshipCodesMapping);

	function showDesignatedMessage() {
		if (isDesignated === undefined) {
			return null;
		}

		return isDesignated ? <p className='grey-caption'>{settings?.designatedBeneficiaryLabel}</p> :
			<ContentSpacer>
				<Banner banner={{
					type: 'info',
					label: <WysiwygWithReactLink content={settings?.notlegallyDesignatedWarningTitle} />,
					description: <WysiwygWithReactLink content={settings?.notlegallyDesignatedWarningDescription} />,
				}} />
			</ContentSpacer>;
	}

	return (
		<>
			<ContentSpacer>
				<p><strong>{beneficiary?.organization?.report_name}</strong></p>
				<p><strong>{beneficiary?.person?.full_name}</strong></p>
				{
					beneficiary?.person &&
					<p className='grey-caption'>{beneficiary?.person?.masked_date_of_birth ? beneficiary?.person?.masked_date_of_birth : settings?.noDobMessage}</p>

				}
				<p className='grey-caption'>{ GetMappedRelationshipByValue(beneficiary?.relationship_code, mappedRelationship) }</p>
				{
					showDesignatedMessage()
				}
			</ContentSpacer>

		</>
	);
}

BeneficiaryView.defaultProps = {
	isDesignated: undefined,
};